/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/hooks/useUserIndustry.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { isAcceptanceTest } from 'hub-http/helpers/env';
import { useGetIndustryQuery } from '../../../../__generated__/chirp/com/hubspot/blueprint/industry/rpc/IndustryRpc.hooks';
export function useUserIndustry() {
  var _data$industryWithLab, _data$industryWithLab2;
  const {
    data,
    loading
  } = useGetIndustryQuery({
    skip: isAcceptanceTest()
  });
  return {
    industry: data === null || data === void 0 || (_data$industryWithLab = data.industryWithLabel) === null || _data$industryWithLab === void 0 ? void 0 : _data$industryWithLab.industry,
    label: data === null || data === void 0 || (_data$industryWithLab2 = data.industryWithLabel) === null || _data$industryWithLab2 === void 0 ? void 0 : _data$industryWithLab2.label,
    loading
  };
}